const QUESTION_LABEL = 'QUESTION_LABEL'


const questions = {
  state: {
    questionList: JSON.parse(window.localStorage.getItem(QUESTION_LABEL) || '[]')
  },
  mutations: {
    ADD_QUESTION: (state, question) => {
      if(state.questionList.find(q=>q.id === question.id)) return
      state.questionList.push(question)
      window.localStorage.setItem(QUESTION_LABEL, JSON.stringify(state.questionList))
    },
    REMOVE_QUESTION: (state, id) => {
      state.questionList = state.questionList.filter(question=>question.id !== id)
      window.localStorage.setItem(QUESTION_LABEL, JSON.stringify(state.questionList))
    },
    CLEAR_QUESTION: (state) => {
      state.questionList = []
      window.localStorage.setItem(QUESTION_LABEL, JSON.stringify(state.questionList))
    }
  },
  actions: {
    AddQuestion: ({commit}, question) => {
      commit('ADD_QUESTION', question)
    },
    RemoveQuestion: ({commit}, id) => {
      commit('REMOVE_QUESTION', id)
    },
    ClearQuestion: ({commit}) => {
      commit('CLEAR_QUESTION')
    }
  }
}

export default questions
